export function SearchBarToUrl(searchBar) {
    return searchBar
        .toLowerCase()
        .trim()
        .replace(/%a0/g, '+')
        .replace(/%/g, '')
        .replace(/\//g, '+')
        .replace(/@/g, '%40')
        .replace(/[àáâãäå]/g, 'a')
        .replace(/æ/g, 'ae')
        .replace(/ç/g, 'c')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/ñ/g, 'n')
        .replace(/[òóôõö]/g, 'o')
        .replace(/œ/g, 'oe')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ýÿ]/g, 'y')
        .replace(/\(/g, '')
        .replace(/\)/g, '')
        .replace(/</g, '')
        .replace(/\\/g, '')
        .replace(/\^/g, '')
        .replace(/;/g, '')
        .replace(/\|/g, '')
        .replace(/~/g, '')
        .replace(/\[/g, '')
        .replace(/\]/g, '')
        .replace(/\{/g, '')
        .replace(/\}/g, '')
        .replace(/%u20AC/g, 'euro')
        .replace(/`/g, '')
        .replace(/°/g, '')
        .replace(/=/g, '+')
        .replace(/\s/g, '+')
        .replace(/,/g, '+')
        .replace(/!/g, '+')
        .replace(/:/g, '+')
        .replace(/'/g, '+')
        .replace(/\?/g, '')
        .replace(/©/g, '')
        .replace(/¿/g, '')
        .replace(/®/g, '')
        .replace(/\./g, '+')
        .replace(/\.../g, '')
        .replace(/\'/g, '+') // eslint-disable-line no-useless-escape
        .replace(/\’/g, '+') // eslint-disable-line no-useless-escape
        .replace(/#/g, '')
        .replace(/½/g, '1+2')
        .replace(/¢/g, '')
        .replace(/,/g, '+')
        .replace(/$/g, '+')
        .replace(/\*/g, '+')
        .replace(/&/g, '+')
        .replace(/\++/g, '+')
        .replace(/\++$/g, '');
}
export function UrlToSearchBar(url) {
    return url.replace(/\+/g, ' ').replace(/%40/g, '@').replace(/%2E/g, '.');
}
